var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconGift = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 3.8V15M8 3.8H5.525c-.365 0-.714-.147-.972-.41a1.413 1.413 0 0 1-.403-.99c0-.371.145-.727.403-.99.258-.262.607-.41.972-.41C7.45 1 8 3.8 8 3.8Zm0 0h2.475c.365 0 .714-.147.972-.41s.403-.619.403-.99-.145-.727-.403-.99a1.363 1.363 0 0 0-.972-.41C8.55 1 8 3.8 8 3.8Zm5.6 3.5v5.46c0 .784 0 1.176-.153 1.476a1.4 1.4 0 0 1-.611.611c-.3.153-.692.153-1.476.153H4.64c-.784 0-1.176 0-1.476-.153a1.4 1.4 0 0 1-.611-.611c-.153-.3-.153-.692-.153-1.476V7.3M1 4.92v1.26c0 .392 0 .588.076.738a.7.7 0 0 0 .306.306c.15.076.346.076.738.076h11.76c.392 0 .588 0 .738-.076a.7.7 0 0 0 .306-.306C15 6.768 15 6.572 15 6.18V4.92c0-.392 0-.588-.076-.738a.7.7 0 0 0-.306-.306c-.15-.076-.346-.076-.738-.076H2.12c-.392 0-.588 0-.738.076a.7.7 0 0 0-.306.306C1 4.332 1 4.528 1 4.92Z",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export default SvgIconGift;